import { FC, useCallback } from "react";
import { AuthWrapper, } from "@components";
import { useController } from "./useController";
import { EmailVerification, LoginForm } from "./components";
import './animations.css';

export const LoginPage: FC = () => {
    const {
        animateOutDirection, temporaryToken, createAccountError,
        isLoadingSignin, signinError, componentIndex,
        animateInDirection, isForgotPasswordEmailSent,
        isLoadingEmailVerification, isLoadingForgotPassword,
        onSignIn, onSentEmail, onResendEmail,
        handleSwitchComponent, onForgotPasswordEmail,
        onClearStore,
    } = useController();

    const renderLoginForm = useCallback(() => (
        <LoginForm 
            isLoading={isLoadingSignin}
            signinError={signinError}
            onSignIn={onSignIn}
            handleFirstTimeClick={()=> handleSwitchComponent(1, 'left')}
            handleForgotPasswordClick={()=> handleSwitchComponent(2, 'right')}
        />
    ), [
        isLoadingSignin, signinError,
        handleSwitchComponent, onSignIn, 
    ]);

    const renderSignUpContainer = useCallback(() => (
        <EmailVerification 
            title="Vérification de votre email"
            subTitle="Veuillez entrer votre adresse email pour recevoir un lien de vérification"
            isLoading={isLoadingEmailVerification}
            isEmailSent={!!temporaryToken}
            error={createAccountError}
            onSentEmail={onSentEmail}
            onResendEmail={onResendEmail}
            onGoToLoginPress={()=> handleSwitchComponent(0, 'right')}
            onClearStore={onClearStore}
        />
    ), [
        isLoadingEmailVerification, temporaryToken,
        createAccountError,
        onResendEmail, onSentEmail,
        handleSwitchComponent, onClearStore,
    ]);

    const renderForgotPasswordContainer = useCallback(() => (
        <EmailVerification 
            title="Réinitialisation du mot de passe"
            subTitle="Veuillez entrer votre adresse email pour recevoir un lien de réinitialisation"
            isLoading={isLoadingForgotPassword}
            isEmailSent={isForgotPasswordEmailSent}
            error={null}
            onSentEmail={onForgotPasswordEmail}
            onResendEmail={onForgotPasswordEmail}
            onGoToLoginPress={()=> handleSwitchComponent(0, 'left')} 
        />
    ), [
        isLoadingForgotPassword, isForgotPasswordEmailSent,
        onForgotPasswordEmail, handleSwitchComponent,
    ]);

    const renderContent = useCallback(()=> {
        switch (componentIndex) {
            case 0:
                return renderLoginForm();
            case 1:
                return renderSignUpContainer();
            case 2:
                return renderForgotPasswordContainer();
            default:
                return renderLoginForm();
        }
    }, [
        componentIndex,
        renderForgotPasswordContainer, 
        renderLoginForm, 
        renderSignUpContainer,
    ]);

    return (
        <AuthWrapper>
            <div className={`
                ${animateOutDirection === 'right' ? 'slide-out-right' : ''}
                ${animateOutDirection === 'left' ? 'slide-out-left' : ''}
                ${animateInDirection === 'right' ? 'slide-in-right' : ''}
                ${animateInDirection === 'left' ? 'slide-in-left' : ''}
            `}>
                {renderContent()}
            </div>
        </AuthWrapper>
    );
};
